export const requestGuidelineText = async (
  url,
  center_id,
  preparation_id,
  token,
  setGuideLineStatus,
  data,
  setIsPreparationGuidelineLoading
) => {
  setGuideLineStatus(false);
  setIsPreparationGuidelineLoading(true)
  const Token = localStorage.getItem("Token");
  // const data = {
  //   center_id: center_id,
  //   preparation_id: preparation_id,
  // };

  const response = await fetch(
    url,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
      credentials: "include"
    }
  )
    .then((response) => response.json())
    .then((data) => {
      //   console.log("GuideLineText", data);
      return data;
    })
    .catch((error) => {
      setGuideLineStatus("");

      console.log("Error", error);
      return {
        error: true,
        message: "failed to fetch the guideline",
      };
    });
  setIsPreparationGuidelineLoading(false)
  return response;
};
